var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activity-card", on: { click: _vm.onClick } },
    [
      _c("div", { staticClass: "left" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "tippy",
                rawName: "v-tippy",
                value: { followCursor: true, placement: "bottom-end" },
                expression: "{ followCursor: true, placement: 'bottom-end' }",
              },
            ],
            staticClass: "avatar-wrapper",
            attrs: { content: "Activity Actor is " + _vm.getActorName() },
          },
          [
            _vm.activity.actor === "user"
              ? _c("AgentAvatar", {
                  attrs: {
                    size: 50,
                    userID: _vm.$_.get(_vm.activity, "actorUser._id"),
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.activity.actor === "chatbot"
              ? _c("Avatar", {
                  staticClass: "avatar",
                  attrs: {
                    username: _vm.getActorName(),
                    src: _vm.baseUrl().concat("static/img/chatbot-bg.png"),
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.activity.actor === "system"
              ? _c("Avatar", {
                  staticClass: "avatar",
                  attrs: {
                    username: _vm.getActorName(),
                    src: _vm.baseUrl().concat("static/img/minilogo4.png"),
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.activity.actor === "visitor"
              ? _c("Avatar", {
                  staticClass: "avatar",
                  attrs: { username: _vm.getActorName() },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "icon" },
              [
                _c("ActivityIconViewer", {
                  attrs: { type: _vm.activity.type },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "activity-content" },
          [_c("ActivityViewer", { attrs: { activity: _vm.activity } })],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.showDate
        ? _c("div", { staticClass: "right" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: { followCursor: true, placement: "bottom-end" },
                    expression:
                      "{ followCursor: true, placement: 'bottom-end' }",
                  },
                ],
                attrs: {
                  content: _vm
                    .$moment(_vm.activity.createdAt)
                    .format("DD/MM/YY hh:mm:ss"),
                },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$moment(_vm.activity.createdAt).fromNow()) +
                    "\n        "
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }